import { httpService } from '@/api/v1/http.service'
import useDownload, { type DownloadParams } from '@/hooks/useDownload'
import { parseColumnsToFetchKeys } from '@/utils/parse-columns-to-fetch-keys'

import { type UserParams } from '../queries/useUsers'

type Params = DownloadParams & UserParams

const useUsersDownload = (usersDownloadParams: Params) =>
  useDownload({
    fileName: 'users',
    requestParams: usersDownloadParams,
    // @ts-expect-error Waits for backend fix - file type should be returned
    downloadMutation: (params: Params) =>
      httpService.panel.panelUsersList(
        {
          id: params.id,
          email: params.email,
          phone_number: params.phoneNumber,
          profile: params.profile,
          status: params.status,
          format: params.format,
          fetchKeys: parseColumnsToFetchKeys(params.columnsKey, params.format)
        },
        { format: 'blob' }
      )
  })

export default useUsersDownload
